<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết công việc</h1>
      <div class="btn-group float-right">
        <button
          v-if="canCoppy(dataDetail.purposes, dataDetail.isMcUploadPhoto)"
          @click="copyLink(dataDetail.id)"
          data-toggle="modal"
          class="f12 font-medium btn btn-outline-secondary"
        >
          <i class="bx bx-edit-alt"></i> Copy link YC bổ sung GPDKKD
        </button>
        <button
          v-if="canUpdate(dataDetail.status)"
          @click="updateWork()"
          data-toggle="modal"
          class="f12 font-medium btn btn-outline-secondary"
        >
          <i class="bx bx-repost"></i> Cập nhật
        </button>
        <button @click="backToCalendar" class="f12 font-medium btn btn-outline-secondary">
          <i class="bx bx-left-arrow-alt"></i> Quay lại
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-sm-6 mb-3">
          <div class="form-detail">
            <h1>Thông tin Công việc</h1>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Thời gian tạo<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ infoCalendar.createdTime | formatDate('HH:mm') }} -
                  {{ infoCalendar.createdTime | formatDate }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="dataDetail.startIntend && dataDetail.endIntend">
              <label for="" class="col-sm-4 col-form-label"
                >Thời gian dự kiến<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ infoCalendar.startIntend | formatDate('HH:mm') }},
                  {{ infoCalendar.startIntend | formatDate }} --
                  {{ infoCalendar.endIntend | formatDate('HH:mm') }},
                  {{ infoCalendar.endIntend | formatDate }}
                </p>
              </div>
            </div>
            <div
              class="form-group form-row"
              v-if="dataDetail.startProcessing && dataDetail.endProcessing"
            >
              <label for="" class="col-sm-4 col-form-label"
                >Thời gian xử lý<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ infoCalendar.startProcessing | formatDate('HH:mm') }},
                  {{ infoCalendar.startProcessing | formatDate }} --
                  {{ infoCalendar.endProcessing | formatDate('HH:mm') }},
                  {{ infoCalendar.endProcessing | formatDate }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="dataDetail.dateEdit">
              <label for="" class="col-sm-4 col-form-label"
                >Thời gian cập nhật<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ dataDetail.dateEdit | formatDate('HH:mm') }} -
                  {{ dataDetail.dateEdit | formatDate }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Nhóm công việc<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ infoCalendar.type }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Tên công việc<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ infoCalendar.purposes | transformData(dataNameCalendar) }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="dataDetail.handlerRes">
              <label for="" class="col-sm-4 col-form-label"
                >Người xử lý<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ infoCalendar.handler }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Người báo<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ infoCalendar.informant }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Nguồn báo<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ infoCalendar.informSource }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Trạng thái<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <span class="badge" :class="infoCalendar.statusCode">
                  {{ infoCalendar.statusCode | transformData(Config.statusCalendarAfs) }}
                </span>
              </div>
            </div>
            <div class="form-group form-row" v-if="dataDetail.result">
              <label for="" class="col-sm-4 col-form-label"
                >Kết quả<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ infoCalendar.result }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Lý do<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ infoCalendar.note }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Mô tả<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ infoCalendar.description }}</p>
              </div>
            </div>
          </div>
          <div class="form-detail">
            <h1>Thông tin Merchant</h1>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Tên Merchant<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ infoMC.name }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Số điện thoại<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ infoMC.phone }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Email<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ infoMC.email }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Địa chỉ<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ infoMC.address }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6 mb-3">
          <div class="img-list-wrapper" v-if="dataDetail.images && dataDetail.images.length > 0">
            <UploadMultiple
              :lsData="dataDetail.images"
              title="Ảnh giải trình"
              titleTag="h1"
              :canUpload="false"
              titleClass="form-inner-heading"
            />
          </div>
          <div
            class="img-list-wrapper"
            v-if="dataDetail.saleOfflineSignedImage && dataDetail.saleOfflineSignedImage.length > 0"
          >
            <UploadMultiple
              :lsData="dataDetail.saleOfflineSignedImage"
              title="Ảnh checkin"
              titleTag="h1"
              :canUpload="false"
              titleClass="form-inner-heading"
            />
          </div>
        </div>
        <div
          class="col-sm-6 mb-3"
          v-if="dataDetail.mcUploadImages && dataDetail.mcUploadImages.length > 0"
        >
          <div class="img-list-wrapper">
            <UploadMultiple
              :lsData="dataDetail.mcUploadImages"
              title="Ảnh Merchant tự upload"
              titleTag="h1"
              :canUpload="false"
              titleClass="form-inner-heading"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Modal cập nhật -->
    <UpdateAFS
      :dataUpdate="dataUpdate"
      :purposesSelected="purposesSelected"
      :fileImage="fileImage"
      :dateRangeProcessing="dateRangeProcessing"
      @updateCalendar="updateCalendar"
      @onHidden="onHidden"
    />

    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>
<script>
  import UpdateAFS from '@/components/UpdateAFS.vue'
  import { CalendarAfsService } from '@/services/calendar-afs.service'
  import { mapGetters } from 'vuex'
  import 'vue-loading-overlay/dist/vue-loading.css'
  import { v4 as uuidv4 } from 'uuid'
  import mxItemAction from './mx-item-action.js'
  import UploadMultiple from '@/components/UploadMultiple.vue'
  import Config from '@/thirdParty/config'
  export default {
    data() {
      return {
        Config,
        userData: JSON.parse(localStorage.getItem('userData')),
        id: this.$route.params.id,
        dataDetail: [],
        infoCalendar: {},
        infoMC: {},
        showLoading: true,
        saleOfflineSignedImage: [],
        fileImage: [],
        dataUpdate: {},
        dateRangeProcessing: {
          startProcessingDate: null,
          endProcessingDate: null,
        },
        purposesSelected: '',
        dataNameCalendar: [],
      }
    },

    components: {
      UpdateAFS,
      UploadMultiple,
    },
    mixins: [mxItemAction],

    created() {
      this.fetchData()
      CalendarAfsService.catCalendar({ size: 100, page: 1 })
        .then(s => s.data?.map(s => ({ id: s.taskCode, text: s.taskName })) ?? [])
        .then(s => (this.dataNameCalendar = s))
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      // Quay lại màn Lịch làm việc AFS
      backToCalendar() {
        this.$router.push('/calendar-afs')
      },

      copyLink(id) {
        navigator.clipboard.writeText(
          `${window._env_?.VUE_APP_BASE_URL ?? process.env.VUE_APP_BASE_URL}/mc-dkkd/${id}`
        )
        this.showSuccessMx('Copy link thành công')
      },
      // Cập nhật
      updateWork() {
        if (this.dataDetail.handlerRes.userName === this.userData.username) {
          this.onChangeType(this.dataDetail.type)
          this.dataUpdate.id = this.dataDetail.id
          this.dataUpdate.selectedStt = this.dataDetail.status
          this.dataUpdate.selectedResult = this.dataDetail.result
          this.dataUpdate.noteUpdate = this.dataDetail.note
          this.dataUpdate.noteUpdateArr = this.dataDetail.note?.split(', ')
          this.dataUpdate.noteUpdateType = this.dataDetail.type
          this.dataUpdate.noteDes = this.dataDetail.description
          this.dataUpdate.saleOfflineSignedImage = this.dataDetail.saleOfflineSignedImage
          this.dateRangeProcessing = {
            startDate: this.dataDetail.startIntend,
            endDate: this.dataDetail.endIntend,
          }
          const mappingData = (arr, type) =>
            arr.forEach(url => {
              const ar = { name: url, url, type, id: uuidv4() }
              this.fileImage.push(ar)
            })
          mappingData(this.dataDetail.images, 'images')
          this.purposesSelected = this.dataDetail.purposes?.[0] ?? null
          setTimeout(() => {
            this.$bvModal.show('select-update-dialog')
          }, 200)
        } else {
          this.showFailMx('Bạn không có quyền thực hiện thao tác này')
        }
      },

      // dữ liệu bảng
      async fetchData() {
        this.showLoading = true
        try {
          const data = await CalendarAfsService.getTaskAFSDetailById({
            id: this.id,
          })
          if (data.success) {
            this.dataDetail = data.data
            this.infoCalendar = {
              description: data.data.description,
              createdTime: data.data.createdTime,
              startIntend: data.data.startIntend,
              endIntend: data.data.endIntend,
              startProcessing: data.data.startProcessing,
              endProcessing: data.data.endProcessing,
              name: data.data.name,
              type: data.data.typeString,
              purposes: data.data.purposeStrings,
              handler: data.data.handlerRes.name,
              informant: data.data.informant,
              informSource: data.data.informSourceString,
              status: data.data.statusString,
              statusCode: data.data.status,
              result: data.data.resultString,
              note: data.data.note,
            }
            this.infoMC = {
              name: data.data.customerInfoRes.merchantName,
              phone: data.data.customerInfoRes.mobile,
              email: data.data.customerInfoRes.email,
              address: data.data.customerInfoRes.address,
            }
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async onChangeType(data) {
        const res = mxItemAction.onChangeType(data)
        res.then(result => {
          this.dataUpdate.resonArr = result[0]
        })
      },
      async updateCalendar(data) {
        try {
          this.showLoading = true
          const res = await CalendarAfsService.UpdateCalendarAFS(data)
          if (res.success) {
            this.showSuccessMx(res.message)
            this.fetchData()
          } else {
            this.showFailMx(res.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
          this.$bvModal.hide('select-update-dialog')
        }
      },
      onHidden() {
        this.fileImage = []
        this.dataUpdate = {}
        this.purposesSelected = ''
        this.dateRangeProcessing = {}
      },
    },
  }
</script>
<style scoped>
  .NEW {
    color: #fff;
    background-color: #6c757d !important;
  }
</style>
